<script setup lang="ts">
import ApplicationBase from '@/components/Applications/ApplicationBase.vue'
import { useI18n } from 'vue-i18n'

// Steps (keep your component names)
import Umsaekjandi from '../Shared/Umsaekjandi.vue'
import Step2 from './Steps/Step2.vue'
import Step3 from './Steps/Step3.vue'
import Undirritun from '../Shared/Undirritun.vue'
import BeginStep from './Steps/ApplicationNewLaunaGreidandiBegin.vue'
// import LokaSkref from '../Shared/LokaSkref.vue'

const { t } = useI18n()

// App config for this flow (type 9 in your legacy)
const APP_ID = 9
const UPDATE_KEY = 'nyr-launagreidandi'

// Order & titles match your legacy flow
const steps = [
  { comp: BeginStep,  titleKey: '' },
  { comp: Umsaekjandi, titleKey: 'umsokn_umsaekjandi_header' },
  { comp: Step2,       titleKey: 'umsokn_nyr_launagreidandi_step2_header' },
  { comp: Step3,       titleKey: 'umsokn_nyr_launagreidandi_step3_header' },

  // Undirritun (signing)
  // ApplicationBase treats the LAST step as signing-friendly,
  // but if you need the penultimate to be the signing one,
  // just place Undirritun before the final step.
  { comp: Undirritun,  titleKey: 'undirritun_umsokn_header1' },

  // Final thank-you/confirmation
//   { comp: LokaSkref,   titleKey: 'umsokn_lokaskref_header' },
]
</script>

<template>
  <ApplicationBase
    :app-id="APP_ID"
    :update-key="UPDATE_KEY"
    :steps="steps"
  />
</template>
